__turbopack_context__.v({
  "xchain-circle-bot": "P7GzXW_xchain-circle-bot",
  "xchain-circle-top": "P7GzXW_xchain-circle-top",
  "xchain-connector-line-1": "P7GzXW_xchain-connector-line-1",
  "xchainAnimationDelayed": "P7GzXW_xchainAnimationDelayed",
  "xchainCircleBotRotation": "P7GzXW_xchainCircleBotRotation",
  "xchainCircleOpacity": "P7GzXW_xchainCircleOpacity",
  "xchainCircleTopRotation": "P7GzXW_xchainCircleTopRotation",
  "xchainConnectorLine": "P7GzXW_xchainConnectorLine",
});
